import { useRef } from "react";
import { triggerEvent } from "../events/bus";
import { EventsRegistry } from "../events";

export default function useColumnResize(tableId, colWidths, setColWidths) {
  const resizingRef = useRef(null);

  const startResize = (e, colIndex) => {
    e.preventDefault();

    resizingRef.current = {
      startX: e.clientX,
      colIndex,
      startWidth: colWidths[colIndex],
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const onMouseMove = e => {
    if (!resizingRef.current) return;

    const { startX, colIndex, startWidth } = resizingRef.current;
    const delta = e.clientX - startX;
    const nextWidth = Math.max(50, startWidth + delta); // min width 50px

    setColWidths(prev => {
      const next = [...prev];
      next[colIndex] = nextWidth;
      return next;
    });

    triggerEvent(EventsRegistry.TABLE_COLUMN_RESIZE, {
      tableId,
      colIndex,
      width: nextWidth,
    });
  };

  const onMouseUp = () => {
    if (!resizingRef.current) return;

    triggerEvent(EventsRegistry.TABLE_COLUMN_RESIZE_END, {
      tableId,
    });

    resizingRef.current = null;
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  };

  return { startResize };
}
